import { render, staticRenderFns } from "./cetificate-card.vue?vue&type=template&id=4d3e9d2a"
import script from "./cetificate-card.vue?vue&type=script&lang=ts"
export * from "./cetificate-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports